import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'common/components/elements/inputs/checkbox-label';
import Icon from 'common/components/elements/icons';

const CheckboxSection = ({
   value,
   name,
   inputProps,
   onChange,
   sectionName,
}) => {
   return (
      <div
         className='flex h-6 gap-1 items-center'
      >
         <div className='flex'>
            <CheckBox
               name={ `${ sectionName }_${ name }` }
               label={ inputProps?.title || '' }
               onChange={ (_, value) => {
                  onChange(name, value)
               } }
               checked={ value }
               textColor='major'
               padding='0'
            />
            {
               'show_verified_checkmark' === name && (
                  <div
                     className='h-6 w-6 flex items-center justify-center'>
                     <Icon
                        name='verify'
                        size='xl'
                        color='action'
                     />

                  </div>
               )
            }
         </div>
      </div>
   );
};


CheckboxSection.propTypes = {
   value: PropTypes.string,
   inputProps: PropTypes.object,
   name: PropTypes.string,
   sectionName: PropTypes.string,
   onChange: PropTypes.func,
};
export default CheckboxSection;
